import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import Modal from "../../Modal";

const Ogen = () => (
    <Modal>
        <div>
            <Panel title={'Spiekkaart'} link={'Spiekkaart tonen'}
                   intro={'wat te doen bij (eerste) signalen van Kindermishandeling?'}
                    open={true}>

                <a href={'https://care-free.app/wp-content/uploads/2022/05/Care-Free-Spiekkaart.pdf'} target={'_blank'}>Download als PDF bestand</a>
                <br/>
                <br/>

                <table style={{
                    border: '1px solid #003d4c',
                    width: '100%',
                }} border={'0'}>
                    <thead>
                    <th colSpan={2}>Spiekkaart: Wat te doen bij (eerste) signalen?</th>
                    </thead>
                    <tbody>
                    <tr>
                        <td style={{
                            verticalAlign: 'top',
                            width: '50%'
                        }}>Bij alle situaties geldt
                        </td>
                        <td>
                            <ul>
                                <li>Leg signalen en andere informatie vanaf het begin vast in het leerlingvolgsysteem
                                    (LVS) in
                                    termen van concrete waarnemingen en gedrag.
                                </li>
                                <li>Zorg voor een sparringpartner: een collega, aandachtsfunctionaris, intern
                                    begeleider,
                                    zorgcoordinator of een andere ondersteuner. Je kunt ook advies vragen bij Veilig
                                    Thuis.
                                </li>
                                <li>Hoe de informatie ook bij je komt, het is altijd aanleiding voor een gesprek met de
                                    leerling
                                    (en/of de ouders).
                                </li>
                                <li>Laat het interpreteren van signalen rond de thuissituatie of psychische ontwikkeling
                                    van de
                                    leerling over aan experts uit de jeugdhulp.
                                </li>
                                <li>Is er sprake van acute of structurele onveiligheid of is hulp organiseren niet
                                    mogelijk, dan
                                    is melden bij Veilig Thuis noodzakelijk! Beoordeel dat niet alleen, maar samen met
                                    de
                                    sparringpartner.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Stel dat …</th>
                        <th>… hoe handel je dan</th>
                    </tr>
                    <tr>
                        <td>
                            … je een (vaag) <strong>‘niet-pluis-gevoel’</strong> hebt bij
                            <ol>
                                <li>Gedrag, verzuim, uitingen, leerprestaties, uiterlijke verschijning en dergelijke van
                                    een
                                    leerling
                                </li>
                                <li>Gedrag of uitspraken van de ouders in relatie tot de leerling waar je je zorgen over
                                    maakt
                                </li>
                            </ol>
                        </td>
                        <td>
                            <ul>
                                <li>Knoop een gesprek aan met de leerling (en eventueel zijn/haar ouders). Peil hoe het
                                    met
                                    hem/haar gaat, bespreek je eigen waarnemingen en zorgen. Misschien heeft de leerling
                                    (of
                                    ouder) er een logische verklaring voor en worden de zorgen waar je je zorgen over
                                    maakt
                                    weggenomen.
                                </li>
                                <li>Observeer de leerling en verzamel extra informatie en signalen over de leerling (en
                                    ouders).
                                    Indien mogelijk in diverse schoolsituaties (in de klas, de pauze, op het
                                    schoolplein, in de
                                    gymles).
                                </li>
                                <li>Vraag aan collega’s of zij die signalen ook zien en/of wat hen opvalt.</li>
                                <li>Maak aantekeningen en neem die op in het LVS. Denk daarbij echter wel aan de
                                    privacy.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            … <strong>je signalen van derden</strong> krijgt, zoals een medeleerling, een bezorgde
                            andere ouder,
                            een collega
                        </td>
                        <td>
                            <ul>
                                <li>Bedank hen voor de informatie.</li>
                                <li>Vraag door: wat is er waar en wanneer en door wie waargenomen? Hoe komt de persoon
                                    aan deze
                                    informatie? Heeft hij/zij dit besproken met de leerling/ouders en zo ja, wat was de
                                    reactie?
                                </li>
                                <li>Zijn meer mensen hiervan op de hoogte? Kijk of je informatie kunt ophalen bij
                                    anderen.
                                </li>
                                <li>Maak een inschatting of deze persoon/jongere jouw hulp nodig heeft en of (samen)
                                    handelen
                                    (volgens de meldcode) nodig is.
                                </li>
                                <li>Arrangeer een gesprek met de leerling (en ouders).</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            … je <strong>signalen van externe partners</strong> krijgt, zoals de jeugdgezondheidszorg of
                            het
                            wijkteam
                        </td>
                        <td>
                            <ul>
                                <li>Bespreek hoe je de leerling en de ouders erbij betrekt.</li>
                                <li>Deel/ontvang alleen informatie die relevant is voor de ontwikkeling van de
                                    leerling.
                                </li>
                                <li>Adviseer de professional in gesprek te gaan met de leerling en de ouders en doorloop
                                    samen
                                    de meldcode als afwegingskader.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            … <strong>de leerling zelf informatie deelt</strong>
                        </td>
                        <td>
                            <ul>
                                <li>Neem de leerling serieus.</li>
                                <li>Zorg voor een ruimte waar je rustig kunt praten. Indien je geen tijd hebt, geef aan
                                    wanneer
                                    je wel tijd hebt of bespreek samen of iemand anders het gesprek kan voeren.
                                </li>
                                <li>Herhaal in eigen woorden wat de leerling zegt. Vat samen en vraag (gedoseerd)
                                    door.
                                </li>
                                <li>Benoem (gedoseerd) de emoties van de leerling en probeer je in te leven.</li>
                                <li>Geef aan wat je voor de leerling kunt doen. Bijvoorbeeld dat hij/zij altijd mag
                                    binnenlopen,
                                    (anoniem) advies inwinnen bij derden (intern begeleider, lid van ondersteuningsteam,
                                    wijkteam).
                                </li>
                                <li>Maak afspraken met de leerling over hoe nu verder.</li>
                                <li>Maak een vervolgafspraak.</li>
                                <li>Loop niet sneller dan de leerling, tenzij hiervoor goede redenen zijn; bijvoorbeeld
                                    als
                                    zijn/haar veiligheid in het geding is. Dan is melden noodzakelijk.
                                </li>
                                <li>Als de leerling vertelt dat er thuis geweld plaatsvindt, meld dat bij Veilig Thuis
                                    en
                                    bespreek met hen welke vervolgstappen je kunt nemen.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            … <strong>de leerling vraagt om geheimhouding</strong> en niet wil dat je er verder met
                            iemand over
                            praat
                        </td>
                        <td>
                            <ul>
                                <li>Beloof nooit geheimhouding.</li>
                                <li>Beloof wel dat je zorgvuldig met de informatie omgaat.</li>
                                <li>En beloof dat je nooit iets zult doen achter de rug van de leerling/ouders om. Je
                                    informeert
                                    hen altijd over een volgende stap.
                                </li>
                                <li>Maak je eigen handelen niet afhankelijk van de toestemming van de leerling/ouder.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Panel>
        </div>
    </Modal>
);


export default Ogen;
